module.exports = __webpack_public_path__ + "img/p2-95.dd99275f.png";